import { render } from "./CriticalDataInventory.vue?vue&type=template&id=fa16204a&scoped=true"
import script from "./CriticalDataInventory.js?vue&type=script&lang=js"
export * from "./CriticalDataInventory.js?vue&type=script&lang=js"

import "./CriticalDataInventory.vue?vue&type=style&index=0&id=fa16204a&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fa16204a"]])

export default __exports__